export default __webpack_public_path__ + "static/media/loading-color.bcf8cb32.gif";